import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const ButtonViewReceipt = styled(NavLink)`
`;

export const CellWrapper = styled.div`
  padding: 6px 8px;
`;

export const CellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5.6px; 
  > span {
    color: var(--luft-primary);
    font-family: "Work Sans";
    font-size: 9.1px;
    font-style: normal;
    font-weight: 500;
    line-height: 15.4px;
    text-transform: capitalize;
  }
`;
